<template lang="pug">
el-dialog(
  title="Atualizar qtd. de resgates disponíveis",
  :visible="visible",
  @update:visible="emit('update:visible', $event)"
)
  p
    | Este cupom atualmente possui&#32;
    |{{ currentlyAvailableRedeems }}&#32;
    | resgates disponíveis.

  el-form(ref="form", :model="data", :rules="rules", label-width="160px")

    el-form-item(label="Operação", prop="operation")
      el-radio-group(v-model="data.operation", placeholder="Selecione a operação")
        el-radio-button(label="INCREMENT") Adicionar
        el-radio-button(label="DECREMENT") Subtrair
        el-radio-button(label="RESET") Redefinir

    el-form-item(label="Quantidade", prop="amount")
      el-input-number(v-model="data.amount", :min="0", :max="1000", controls-position="right")

  template(slot="footer", style="text-align: right")
    el-button(type="primary", @click="promptUpdate", :loading="saving") Atualizar qtd.
</template>
<script setup lang="ts">
import { useMessage } from '@/utils/Message'
import { useConfirm } from '@/utils/MessageBox'
import { ref, reactive, watch } from 'vue'

import SubscriptionGiftCouponService from '@/services/promotions/SubscriptionGiftCouponService'

const props = defineProps({
  couponId: {
    type: String,
    required: true
  },
  currentlyAvailableRedeems: {
    type: Number,
    required: true
  },
  visible: {
    type: Boolean,
    required: true
  },
})

const emit = defineEmits(['update:visible', 'updated'])

const confirm = useConfirm()
const message = useMessage()

const form = ref()
const rules = ref({
  operation: [
    { required: true, message: 'Por favor, selecione a operação a ser realizada', trigger: 'blur' }
  ],
  amount: [
    { required: true, message: 'Por favor, defina a quantidade', trigger: 'blur' }
  ]
})

const data = reactive({
  operation: null,
  amount: undefined
})

const saving = ref(false)

const promptUpdate = async () => {
  try {
    await form.value.validate()
  } catch(e) {
    message.warning("Verifique os dados preenchidos")

    return
  }

  var title = ''
  var msg = ''
  switch (data.operation) {
    case 'INCREMENT':
      title = 'Adicionar resgates'
      msg = `Você tem certeza de que deseja adicionar ${data.amount} ao número de cupons disponíveis?`
      break
    case 'DECREMENT':
      title = 'Subtrair resgates'
      msg = `Você tem certeza de que deseja subtrair ${data.amount} do número de cupons disponíveis?`
      break
    case 'RESET':
      title = 'Redefinir número de resgates'
      msg = `Você tem certeza de que deseja redefinir o número de cupons disponíveis para ${data.amount}?`
      break
    default:
      msg = 'Operação inválida'
      break
  }

  confirm(msg, title, {
    confirmButtonText: 'Sim, atualizar',
    cancelButtonText: 'Cancelar',
    type: 'warning'
  }).then(async () => {
    return await update()
  })
}

const update = async () => {
  try {
    const request = {
      operation: data.operation,
      amount: data.amount
    }

    await SubscriptionGiftCouponService.updateAvailableRedeems(props.couponId, request)
    message.success("Qtd. de resgates atualizada")

    emit('updated')
    emit('update:visible', false)
  } catch(e) {
    message.error("Erro ao atualizar cupom")
  }
}

watch(() => props.visible, () => {
  if (props.visible) {
    data.operation = null
    data.amount = undefined
  }
})
</script>
